import { render, staticRenderFns } from "./AdminOrderImport.vue?vue&type=template&id=ee15976e&scoped=true"
import script from "./AdminOrderImport.vue?vue&type=script&lang=js"
export * from "./AdminOrderImport.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderImport.vue?vue&type=style&index=0&id=ee15976e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee15976e",
  null
  
)

export default component.exports